import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { IStaticMethods } from 'flyonui/flyonui';
import { HelpersService } from './services/helpers.service';
import { from, Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthenticationService } from './authentication/authentication.service';
import { CommonModule } from '@angular/common';
import { GigyaService } from './authentication/gigya.service';

declare global {
  interface Window {
    HSStaticMethods: IStaticMethods;
    MSStream: any
  }
}

@Component({
  imports: [RouterOutlet, CommonModule],
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  constructor(private router: Router,
              private helpersService: HelpersService,
              private authService: AuthenticationService,
              private gigyaService: GigyaService) { }

  public timeOutFlyOn: any;
  public resolveUser: boolean = false;

  private appVersion = require("package.json").version;



  ngOnInit() {
    this.checkJWTStatus().subscribe({
      next: () => { this.resolveUser = true; },
      error: () => {
        // this.authService.clearStorage();
        this.resolveUser = true;
      }
    });

    if (this.helpersService.isBrowser) {
      this.router.events.subscribe((event: any) => {
        if (event instanceof NavigationEnd) {
          this.autoInitHs();
        }
      });
      this.helpersService.onResetAutoInitHS.subscribe((event: any) => {
          this.autoInitHs();
      });
    }

    console.log("MU app Version: v" + this.appVersion);
  }

  private checkJWTStatus(): Observable<any> {
    return from(this.gigyaService.getUserJWT()).pipe(
      map((res) => { return true; }),
      catchError((err) => {
        return this.helpersService.handleError(err);
      })
    );
  }

  private autoInitHs() {
    if (this.timeOutFlyOn) clearTimeout(this.timeOutFlyOn);
    this.timeOutFlyOn = setTimeout(() => {
      window.HSStaticMethods.autoInit();
    }, 100);
  }
}
